import { PRODUCT_LINE_CODE } from '../../../shared/constants/product-lines-codes';
import { cementBag } from './cement-bag';
import { multiProduct } from '@ordersnproducts/modules/one-click-order/configs/mx/multiproduct';
import { bulkCement } from './bulk-cement';

export const mxConfig = {
  [PRODUCT_LINE_CODE.BAG_CEMENT]: cementBag,
  [PRODUCT_LINE_CODE.MULTI_PRODUCT]: multiProduct,
  [PRODUCT_LINE_CODE.BULK_CEMENT]: bulkCement,
};
